import { Heading, Text } from '@apollo/orbit';
import React from 'react';

import { HistogramTooltipProps } from 'src/components/charts/Histogram/HistogramTooltip';
import { format } from 'src/lib/format';

export const InsightsHistogramTooltip = ({
  title,
  stackCounts = [],
  activeSeries,
  stacks = [],
  rangeBeginMs,
  rangeEndMs,
  percentile = 0,
}: HistogramTooltipProps) => {
  return (
    <div>
      {title ? (
        <Heading variant="title" className="text-white">
          {title}
        </Heading>
      ) : null}
      {stackCounts.map((value, stackId) => {
        if (activeSeries && !activeSeries[stackId]) return null;
        const { label, unit } = stacks[stackId] ?? {};
        return (
          <div className="mt-3" key={`${value.label}${label}${unit}`}>
            <Text as="div" variant="label" className="text-white">
              {label || ''}
            </Text>
            <div>
              {value.label}
              {unit}
            </div>
          </div>
        );
      })}
      <Text as="div" variant="label" className="mt-3 text-white">
        Range
      </Text>
      <div>
        {format.ms(rangeBeginMs, 1, false)} - {format.ms(rangeEndMs, 1, false)}
      </div>
      <Text as="div" variant="label" className="mt-3 text-white">
        Percentile
      </Text>
      <div>
        {Number(percentile.toPrecision(2))}% |{' '}
        {Number((100 - percentile).toPrecision(2))}%
      </div>
    </div>
  );
};
